import { BASE_API_URL, BASE_AUTH_API_URL } from "@/constants";
import { fetcher } from "@/lib/fetcher.config";
import { mockGetCurrentUser } from "@/mocks";
import { ApiResponse } from "@/types";
import { GetMeResponse } from "@/types/auth.type";
import axios from "axios";

export async function login() {
  return await axios.post(`${BASE_API_URL}/login`, {
    headers: { "Content-Type": "application/json" },
  });
}

// Logout the current user
export async function logout({ state }: { state: string }): Promise<ApiResponse<void>> {
  return await axios.get(`/api/oauth/logout`, {
    params: { state: state },
    headers: { "Content-Type": "application/json" },
  });
}

// // Refresh token
// export async function refreshToken(): Promise<ApiResponse<void>> {
//   return fetcher(`${BASE_AUTH_API_URL}/auth/refresh`, {
//     method: "POST",
//     skipTokenRefresh: true, // Prevent infinite loop
//   });
// }

export async function getCurrentUser(): Promise<GetMeResponse> {
  // For development/testing, you can use the mock instead:
  return mockGetCurrentUser("admin", 1000);
  return fetcher(`${BASE_AUTH_API_URL}/me`);
}
